import React from 'react';
import { CustomDialog } from '../Components/CustomDialog';
import { dialogConfigs } from '../Utils/PMHelper';
import { TEnvironment } from '../Types/channel.types';

type AddEnvironmentDialogProps = {
    isOpen: boolean;
    onClose: () => void;
    onSave: (data: any) => void;
    isLoading?: boolean;
    editData?: TEnvironment | null;
    mode?: 'create' | 'edit';
    hasProductionEnv?: boolean;
}

export const AddEnvironmentDialog = ({ isOpen, onClose, onSave, isLoading = false, editData = null, mode = 'create', hasProductionEnv = false }: AddEnvironmentDialogProps) => {

    const getFields = () => {
        const baseFields = [...dialogConfigs.addEnvironment.fields];

        return baseFields.map(field => {
            // Handle production checkbox field
            if (field.name === 'useAsProduction') {
                // In edit mode, disable if another environment is production
                if (mode === 'edit' && editData) {
                    const isDisabled = hasProductionEnv && !editData.isProduction;
                    return {
                        ...field,
                        defaultValue: editData.isProduction,
                        disabled: isDisabled
                    };
                }

                // In create mode, disable if a production environment already exists
                if (mode === 'create') {
                    return {
                        ...field,
                        disabled: hasProductionEnv
                    };
                }
            }

            // Handle other fields in edit mode
            if (mode === 'edit' && editData) {
                switch (field.name) {
                    case 'environmentName':
                        return { ...field, defaultValue: editData.name };
                    default:
                        return field;
                }
            }

            return field;
        });
    };

    return (
        <CustomDialog
            isOpen={isOpen}
            onClose={onClose}
            title={mode === 'edit' ? 'Edit Environment' : dialogConfigs.addEnvironment.title}
            fields={getFields()}
            onSave={onSave}
            saveButtonText={mode === 'edit' ? 'Update' : 'Create'}
            isLoading={isLoading}
        />
    );
};